const React = require("react");
const Link = require("../../core/view/Link");
const {
	attemptsBar,
	statsIcon,
	historyIcon,
	screenshot,
	colorLegend,
	pieGraphIcon,
	inlineIcon,
	lockIcon,
	homeworkIcon,
} = require("../../core/util/CopyShared");
const AssetsUtil = require("../../core/util/AssetsUtil");

const getCopy = function(styles, options = {}) {
	return [
		{
			hash: "overview",
			titleLevel: 1,
			contents: (
				<div className={styles.rowContainer}>
					<div className={styles.column6}>
						<div className={styles.overviewText}>
							The Reports page is where you view progress and activity for your
							classes and students. To access your Reports, click REPORTS in the
							top menu.
							<p>
								{"This will take you to your "}
								<Link
									to={options.supportLinkURL("reports", "class-report-pages")}
									className={styles.link}
								>
									Class
								</Link>
								{" page if you have one class, or to your "}
								<Link
									to={options.supportLinkURL("reports", "school-report-pages")}
									className={styles.link}
								>
									School
								</Link>
								{" page if you have more than one class."}
							</p>
						</div>
						<div className={styles.videoArea}>
							<iframe
								className={styles.video}
								src="https://www.youtube.com/embed/9GQirX_j9o0"
								frameBorder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								allowFullScreen
							/>
						</div>
						<br />
						<div className={styles.overviewText}>
							<Link
								to={options.supportLinkURL("reports", "assignments")}
								className={styles.link}
							>
								Assignments
							</Link>{" "}
							have been added since the creation of this video.
						</div>
					</div>
					<div className={styles.column4}>
						<div className={styles.tableOfContents}>
							<div className={styles.tocHeader}>CONTENTS</div>
							<ul className={styles.blueBulletList}>
								<li>
									<Link
										to={options.supportLinkURL(
											"reports",
											"search-and-navigation"
										)}
										className={styles.link}
									>
										Search and Navigation
									</Link>
								</li>
								<li>
									<Link
										to={options.supportLinkURL(
											"reports",
											"reading-the-reports"
										)}
										className={styles.link}
									>
										Reading the Reports
									</Link>
									<ul className={styles.redSquareBulletList}>
										<li>
											<Link
												to={options.supportLinkURL("reports", "icons")}
												className={styles.link}
											>
												Icons
											</Link>
										</li>
									</ul>
								</li>
								<li>
									<Link
										to={options.supportLinkURL("reports", "assignments")}
										className={styles.link}
									>
										Assignments
									</Link>
								</li>
								<li>
									<Link
										to={options.supportLinkURL("reports", "locks")}
										className={styles.link}
									>
										Locks
									</Link>
								</li>
								<li>
									<Link
										to={options.supportLinkURL(
											"reports",
											"school-report-pages"
										)}
										className={styles.link}
									>
										School Report Pages
									</Link>
								</li>
								<li>
									<Link
										to={options.supportLinkURL("reports", "class-report-pages")}
										className={styles.link}
									>
										Class Report Pages
									</Link>
									<ul className={styles.redSquareBulletList}>
										<li>
											<Link
												to={options.supportLinkURL("reports", "class-progress")}
												className={styles.link}
											>
												Progress
											</Link>
											<ul className={styles.yellowBulletList}>
												<li>
													<Link
														to={options.supportLinkURL(
															"reports",
															"class-level"
														)}
														className={styles.link}
													>
														Class BA Level Reports
													</Link>
												</li>
												<li>
													<Link
														to={options.supportLinkURL(
															"reports",
															"class-chapter"
														)}
														className={styles.link}
													>
														Class Chapter Reports
													</Link>
												</li>
												<li>
													<Link
														to={options.supportLinkURL(
															"reports",
															"class-lesson"
														)}
														className={styles.link}
													>
														Class Lesson Reports
													</Link>
												</li>
												<li>
													<Link
														to={options.supportLinkURL(
															"reports",
															"class-problem"
														)}
														className={styles.link}
													>
														Problem Reports
													</Link>
												</li>
											</ul>
										</li>
									</ul>
								</li>
								<li>
									<Link
										to={options.supportLinkURL(
											"reports",
											"student-report-pages"
										)}
										className={styles.link}
									>
										Student Report Pages
									</Link>
									<ul className={styles.redSquareBulletList}>
										<li>
											<Link
												to={options.supportLinkURL(
													"reports",
													"student-progress"
												)}
												className={styles.link}
											>
												Progress
											</Link>
											<ul className={styles.yellowBulletList}>
												<li>
													<Link
														to={options.supportLinkURL(
															"reports",
															"student-progress-ba-level"
														)}
														className={styles.link}
													>
														Student BA Level Reports
													</Link>
												</li>
												<li>
													<Link
														to={options.supportLinkURL(
															"reports",
															"student-progress-chapter-reports"
														)}
														className={styles.link}
													>
														Student Chapter Reports
													</Link>
												</li>
												<li>
													<Link
														to={options.supportLinkURL(
															"reports",
															"student-progress-lesson-reports"
														)}
														className={styles.link}
													>
														Student Lesson Reports
													</Link>
												</li>
												<li>
													<Link
														to={options.supportLinkURL(
															"reports",
															"student-problem"
														)}
														className={styles.link}
													>
														Problem Reports
													</Link>
												</li>
											</ul>
										</li>
										<li>
											<Link
												to={options.supportLinkURL(
													"reports",
													"student-activity"
												)}
												className={styles.link}
											>
												Activity
											</Link>
										</li>
									</ul>
								</li>
								<li>
									<Link
										to={options.supportLinkURL(
											"reports",
											"class-puzzle-lab-report"
										)}
										className={styles.link}
									>
										Puzzle Lab Report Pages
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "search-and-navigation",
			title: "SEARCH AND NAVIGATION",
			titleLevel: 1,
			contents: (
				<div>
					There are a few navigation tools that will help you get around the
					Reports section.
					{screenshot(styles, "report-navigation-with-arrows2", false)}
				</div>
			),
		},
		{
			hash: "search-and-navigation-breadcrumbs",
			title: "Breadcrumbs",
			titleLevel: 4,
			contents: (
				<div>
					Use the "breadcrumbs" near the top-left of any Report page to
					navigate, and switch to the previous or next item in any category
					using the arrows in the top-right.
				</div>
			),
		},
		{
			hash: "search-and-navigation-dropdown-menus",
			title: "Dropdown Menus",
			titleLevel: 4,
			contents: (
				<div>
					While viewing progress in a report, you can navigate to a BA level,
					chapter, or lesson using the menus below the class name.
				</div>
			),
		},
		{
			hash: "search-and-navigation-search",
			title: "Search",
			titleLevel: 4,
			contents: (
				<div>
					You can search for any class or student using the search bar in the
					top-right corner of any Reports page.
				</div>
			),
		},
		{
			hash: "search-and-navigation-tabs",
			title: "Tabs",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						Use the tabs near the top-right to switch views. For students, you
						can switch between viewing progress and activity. For schools, you
						can switch between classes and students.
					</p>
					<p>
						You can also navigate by clicking any blue link on any report page.
					</p>
				</div>
			),
		},
		{
			hash: "reading-the-reports",
			title: "Reading the Reports",
			titleLevel: 1,
			contents: (
				<div>
					<p>
						The reports on BA Online help you keep track of student progress.
					</p>
					Stars are the primary indicator of proficiency in Beast Academy
					Online. Students can earn up to 3 stars on each lesson.
					{" A student who earns 1 star "}
					{historyIcon(styles, "stars", false, "", {
						keySuffix: "1starreadingreports",
						numStars: 1,
						inline: true,
						hideStarIcon: true,
					})}
					{" is proficient and ready to continue. A student who earns 2 stars "}
					{historyIcon(styles, "stars", false, "", {
						keySuffix: "2starreadingreports",
						numStars: 2,
						inline: true,
						hideStarIcon: true,
					})}
					{" is advanced. Earning 3 stars "}
					{historyIcon(styles, "stars", false, "", {
						keySuffix: "3starreadingreports",
						numStars: 3,
						inline: true,
						hideStarIcon: true,
					})}
					{" is an expert-level performance."}
					<p>
						If you see a lot of blue, your student is doing well. The darker the
						blue, the stronger the performance.
					</p>
					<p>
						The monster icon{" "}
						{inlineIcon(
							styles,
							AssetsUtil.getGeneralIcon("icon-bonus-beast-yellow")
						)}{" "}
						indicates enrichment lessons that go beyond what is typically taught
						in most classrooms.
					</p>
					A red exclamation point{" "}
					{historyIcon(styles, "intervened", false, "", {
						keySuffix: "intervenedreadingreports",
						inline: true,
					})}{" "}
					indicates that a student is struggling in an area and may need help.
					<p>Find all of the progress icons below.</p>
				</div>
			),
		},
		{
			hash: "icons",
			title: "ICONS",
			titleLevel: 2,
			horizontalRule: true,
			contents: null,
		},
		{
			hash: "totals",
			title: "Totals",
			titleLevel: 4,
			contents: (
				<div>
					{statsIcon(
						styles,
						"star",
						<span>
							<b>Stars</b> are the primary indicator of proficiency in Beast
							Academy. Students can earn up to 3 stars in each lesson. One star
							indicates that a student is proficient and ready to move on, while
							3 stars indicates expert-level mastery of a topic.
						</span>,
						styles.detailIcon
					)}
					<br />
					{statsIcon(
						styles,
						"trophy",
						<span>
							<b>Trophy problems</b> are offered for some lessons. Trophy
							problems are intended to challenge students who really want to
							bend their brains. In order to play a lesson's trophy problem, a
							student must first earn enough stars in the lesson.
						</span>,
						styles.detailIcon
					)}
					<br />
					{statsIcon(
						styles,
						"check",
						<span>
							<b>Problems answered correctly</b> are a good indicator of how
							much effort a student has put into Beast Academy.
						</span>,
						styles.detailIcon
					)}
					<br />
					{statsIcon(
						styles,
						"time",
						<span>
							<b>Time</b> is only counted while a student is playing a lesson,
							reading the online Guide, or watching an instructional video.
						</span>,
						styles.detailIcon
					)}
					<br />
					{statsIcon(
						styles,
						"student",
						<span>
							<b>Total students</b> are listed for classes.
						</span>,
						styles.detailIcon
					)}
				</div>
			),
		},
		{
			hash: "colors",
			title: "Colors",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						Colors are used to indicate how students have done in lessons and
						chapters.
					</p>
					<div>{colorLegend(styles, true)}</div>
				</div>
			),
		},
		{
			hash: "lesson-progress",
			title: "Lesson Progress",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						Lesson icons show how students have done. Click any lesson icon to
						view more detailed information including individual problems,
						student responses (where available), and solutions.
					</p>
					{historyIcon(
						styles,
						"stars",
						false,
						"3 stars plus a trophy earned.",
						{
							keySuffix: "3starswithtrophy",
							numStars: 3,
							hasTrophy: true,
							hideStarIcon: true,
						}
					)}
					<br />
					{historyIcon(
						styles,
						"stars",
						false,
						"3 stars, and there is an unearned trophy problem available.",
						{
							keySuffix: "3starsnosuffix",
							numStars: 3,
							trophyAvailable: true,
							hideStarIcon: true,
						}
					)}
					<br />
					{historyIcon(styles, "stars", false, "2 stars earned.", {
						keySuffix: "2stars",
						numStars: 2,
						hideStarIcon: true,
					})}
					<br />
					{historyIcon(styles, "stars", false, "1 star earned.", {
						keySuffix: "1star",
						numStars: 1,
						hideStarIcon: true,
					})}
					<br />
					{historyIcon(styles, "stars", false, "0 stars earned.", {
						keySuffix: "0stars",
						numStars: 0,
						hideStarIcon: true,
					})}
					<br />
					{historyIcon(
						styles,
						"partial",
						false,
						"In progress. The blue indicates the fraction of problems that have been completed in the lesson.",
						{
							percentComplete: 0.6,
						}
					)}
					<br />
					{historyIcon(
						styles,
						"intervened",
						false,
						"Alert! The lesson was ended early after a student missed some early questions, or they quit a test. They may need help."
					)}
					<br />
					{historyIcon(
						styles,
						"empty",
						false,
						"Lessons that have not been started."
					)}
					<br />
					{historyIcon(
						styles,
						null,
						false,
						"Enrichment lessons that have a monster icon can be considered optional. They are great for students who could use an extra challenge or want to learn a new topic.",
						{
							hideStarIcon: true,
							backgroundIconType: "bonus",
						}
					)}
					<br />
					{pieGraphIcon(
						styles,
						"A pie chart gives a summary of progress for all students in a class.",
						[
							{color: 3, percent: 0.34},
							{color: 2, percent: 0.24},
							{color: 1, percent: 0.08},
							{color: "red", percent: 0.05},
						]
					)}
					<br />
					<p>
						Additional icons and colors are used in the{" "}
						<Link
							to={options.supportLinkURL("reports", "puzzle-lab-reports")}
							className={styles.link}
						>
							Puzzle Lab Reports
						</Link>
						.
					</p>
				</div>
			),
		},
		{
			hash: "assignments",
			title: "Assignments",
			titleLevel: 1,
			contents: (
				<div>
					<div>
						Lessons can be assigned to all students in a class from the Class
						Chapter Reports page. Click on any binder clip to assign or
						un-assign a lesson (blue{" "}
						{homeworkIcon(
							styles,
							"assigned",
							{isAcademy: false},
							null,
							styles.classHomeworkIcon
						)}{" "}
						means assigned and gray{" "}
						{homeworkIcon(
							styles,
							"un-assigned",
							{isAcademy: false},
							null,
							styles.classHomeworkIcon
						)}{" "}
						means not assigned).
					</div>
					<br />
					{screenshot(styles, "assignmentsReports1", false)}
					<p>
						You can use the toggle on the left to switch between viewing all
						lessons or assigned lessons in a chapter.
					</p>
					{screenshot(styles, "assignmentsReports2", false)}
					<p>
						You cannot assign a lesson that has been manually locked. You must
						remove the manual lock before assigning the lesson. Learn more about
						locks{" "}
						<Link
							to={options.supportLinkURL("reports", "locks")}
							className={styles.link}
						>
							here
						</Link>
						.
					</p>
					<p>
						The Class Chapter Reports is the only page where lessons can be
						assigned or un-assigned. Assignments cannot be customized for
						individual students.
					</p>
				</div>
			),
		},
		{
			hash: "locks",
			title: "Locks",
			titleLevel: 1,
			contents: (
				<div>
					There are two ways to lock and unlock content in Beast Academy Online.
					Teachers can set a lock scheme on the{" "}
					<Link to={options.supportLinkURL("accounts")} className={styles.link}>
						Accounts page
					</Link>
					{" and ignore individual lock settings."}
				</div>
			),
		},
		{
			hash: "locks-schemes",
			title: "Lock Scheme",
			titleLevel: 4,
			contents: (
				<div>
					{"Set the default lock scheme on the "}
					<Link to={options.supportLinkURL("accounts")} className={styles.link}>
						Accounts page
					</Link>
					{". We offer three lock schemes. Lock schemes can be overridden by "}
					<Link
						to={options.supportLinkURL("reports", "locks-individual")}
						className={styles.link}
					>
						individual locks
					</Link>
					.
					<ul>
						<li>
							<b>Sequential</b>
							<br />
							Only the first lesson in each chapter up to the start of a
							student's BA level is unlocked. Students unlock new lessons and
							chapters as they earn stars.
						</li>
						<li>
							<b>All Chapters</b>
							<br />
							The first lesson in every chapter in every BA level is unlocked.
							Students can play any chapter in any BA level and unlock new
							lessons as they earn stars.
						</li>
						<li>
							<b>Free Play</b>
							<br />
							Every lesson is unlocked. Students can play any lesson in any
							chapter in any BA level. You can also choose whether or not to
							unlock all chapter tests as part of the Free Play lock scheme.
						</li>
					</ul>
				</div>
			),
		},
		{
			hash: "locks-individual",
			title: "Individual Locks",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						Individual locks give greater control over what lessons students can
						and cannot play in BA Online. You can manually lock and unlock
						specific lessons, tests, chapters, and levels from your Reports
						pages.
					</p>
					{screenshot(styles, "teacherLocks", true)}
					<p>
						Click on any lock icon to change its status. Clicking a lock icon
						changes both its color (blue for manual or gray for automatic) and
						its shape (locked or unlocked).
					</p>
					<div className={styles.lockList}>
						{lockIcon(
							styles,
							"classLock",
							<span>
								A <b>key</b> indicates that you have not changed the default
								lock setting in a level, chapter, or lesson. The lesson may be
								locked for some students and unlocked for others, depending on
								your{" "}
								<Link
									to={options.supportLinkURL("reports", "locks-schemes")}
									className={styles.link}
								>
									individual locks
								</Link>
							</span>,
							styles.classLockIcon
						)}
						{lockIcon(
							styles,
							"autoUnlocked",
							<span>
								The gray <b>unlocked</b> icon means that this grade, chapter, or
								lesson is automatically unlocked. It will remain unlocked if you
								do not change a setting.
							</span>,
							styles.classLockIcon
						)}
						{lockIcon(
							styles,
							"autoLocked",
							<span>
								The gray <b>locked</b> icon means that this grade, chapter, or
								lesson is automatically locked. A student may unlock this lesson
								with progress.
							</span>,
							styles.classLockIcon
						)}
						{lockIcon(
							styles,
							"forceUnlocked",
							<span>
								The blue <b>unlocked</b> icon means that you have manually
								unlocked this grade, chapter, or lesson. It will remain unlocked
								unless you change a setting. Manual locks override class default
								settings, and student-level locks override any class-level locks
								that you have set manually.
							</span>
						)}
						{lockIcon(
							styles,
							"forceLocked",
							<span>
								The blue <b>locked</b> icon means that you have manually locked
								this grade, chapter, or lesson. Manual locks override class
								default settings, and student-level locks override any
								class-level locks that you have set manually.
							</span>
						)}
					</div>
					<p>More:</p>
					<ul>
						<li>
							Manual (blue) locks will stay that way unless you change them
							individually by clicking on them.
						</li>
						<li>
							Manual locks for students override class locks. For example, if
							you have manually locked Chapter 3 for Jamie, unlocking it for the
							class will not unlock it for Jamie. Similarly, class locks
							override school locks.
						</li>
						<li>
							Manually locked items cannot be automatically unlocked by student
							progress.
						</li>
						<li>
							Manually locking a level or chapter manually locks all of its
							contents.
						</li>
						<li>
							Unlocking a manually-locked level or chapter returns the
							individual locks within it to their previous status.
						</li>
						<li>
							Unlocking a BA level automatically unlocks its first chapter.
						</li>
						<li>Unlocking a chapter automatically unlocks its first lesson.</li>
						<li>
							You must unlock a BA level or chapter to unlock any of its
							contents.
						</li>
						<li>
							You cannot manually adjust locks for a BA Level or Chapter that
							contains assigned lessons. Learn more about assignments{" "}
							<Link
								to={options.supportLinkURL("reports", "assignments")}
								className={styles.link}
							>
								here
							</Link>
							.
						</li>
						<li>
							Assigning a lesson manually unlocks it. You must un-assign it to
							lock it. Learn more about assignments{" "}
							<Link
								to={options.supportLinkURL("reports", "assignments")}
								className={styles.link}
							>
								here
							</Link>
							.
						</li>
					</ul>
				</div>
			),
		},
		{
			hash: "school-report-pages",
			title: (
				<div className={styles.outer}>
					<span className={styles.baoIcon}>g</span>
					SCHOOL REPORT PAGES
				</div>
			),
			titleLevel: 1,
			contents: (
				<div>
					<p>
						School report pages are available to administrators and to teachers
						who teach multiple classes. These pages allow teachers to view data
						for all of the students and classes they teach. Administrators can
						view all students and classes.
					</p>
					{screenshot(
						styles,
						"school-report-page2",
						true,
						styles.largeScreenshot
					)}
					<br />
					You can switch between class and student views using the tabs in the
					top-right, and filter the data in the table by grade and time using
					the dropdown menus below the tabs.
					<br />
					<br />
					<div className={styles.learnMoreInfo}>
						{"Click the "}
						<div className={styles.learnMoreIcon}>
							<span>?</span>
						</div>
						{" icon next to any item to view more about it."}
					</div>
				</div>
			),
		},
		{
			hash: "class-report-pages",
			title: (
				<div className={styles.outer}>
					<span className={styles.baoIcon}>Q</span>
					CLASS REPORT PAGES
				</div>
			),
			titleLevel: 1,
			contents: (
				<div>
					<p>
						Class pages allow you to view progress for an entire class of
						students.
					</p>
					{screenshot(
						styles,
						"class-report-pages",
						true,
						styles.largeScreenshot
					)}
					<p>
						Below the class name are cumulative totals for the whole class.
						Learn more about what these icons stand for in the{" "}
						<Link
							to={options.supportLinkURL("reports", "icons")}
							className={styles.link}
						>
							icons
						</Link>{" "}
						section above.
					</p>
					<p>
						Use the BA level, chapter, and lesson menus to view specific reports
						for the class. You can view class reports for any BA Level, Chapter,
						Lesson, or the Puzzle Lab.
					</p>
					<p>
						You can also navigate by clicking any blue link, including chapter
						and lesson numbers, dates (which take you to the{" "}
						<Link
							to={options.supportLinkURL("reports", "student-activity")}
							className={styles.link}
						>
							activity calendar
						</Link>{" "}
						for a student), and student names (which will take you to their{" "}
						<Link
							to={options.supportLinkURL("reports", "student-report-pages")}
							className={styles.link}
						>
							student page
						</Link>
						).
					</p>
					<div className={styles.learnMoreInfo}>
						{"Click the "}
						<div className={styles.learnMoreIcon}>
							<span>?</span>
						</div>
						{" icon next to any item to view more about it."}
					</div>
				</div>
			),
		},
		{
			hash: "class-progress",
			title: "Progress",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					{"The "}
					<div className={styles.reportTab}>
						<span className={styles.reportTabIcon}>E</span>
						Progress
					</div>
					{
						" tab lets you view reports on student performance. We expect to add an "
					}
					<div className={styles.reportTab}>
						<span className={styles.reportTabIcon}>A</span>
						Activity
					</div>
					{" tab for class reports in a future update."}
				</div>
			),
		},
		{
			hash: "class-level",
			title: "Class BA Level Reports",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							Every student has a color-coded cumulative bar graph for their
							total progress across a full BA Level, as well as a bar graph for
							each chapter. View what the colors stand for{" "}
							<Link
								to={options.supportLinkURL("reports", "colors")}
								className={styles.link}
							>
								here
							</Link>
							.
							<br />
							<br />
							<div>
								{pieGraphIcon(
									styles,
									"A pie chart gives a summary of progress for all students in a class in each chapter.",
									[
										{color: 3, percent: 0.34},
										{color: 2, percent: 0.24},
										{color: 1, percent: 0.08},
									]
								)}
							</div>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, "class-report-pages", true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "class-chapter",
			title: "Class Chapter Reports",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							<p>
								Every student has a color-coded cumulative bar graph for their
								total progress across a full BA Chapter. View what the colors
								stand for{" "}
								<Link
									to={options.supportLinkURL("reports", "colors")}
									className={styles.link}
								>
									here
								</Link>
								.
							</p>
							<p>
								For each student, their best result is shown for each lesson.
								Learn all about lesson progress icons{" "}
								<Link
									to={options.supportLinkURL("reports", "lesson-progress")}
									className={styles.link}
								>
									here
								</Link>
								.
							</p>
							<p>
								The date given is the date a student most recently played in
								this chapter.
							</p>
							<div>
								{historyIcon(
									styles,
									"stars",
									false,
									"Click any lesson icon to view individual problems, student responses (where available), and solutions.",
									{
										keySuffix: "2stars",
										numStars: 2,
										hideStarIcon: true,
									}
								)}
								<br />
								{pieGraphIcon(
									styles,
									"A pie chart gives a summary of progress for all students in each lesson.",
									[
										{color: 3, percent: 0.34},
										{color: 2, percent: 0.15},
										{color: 1, percent: 0.15},
										{color: "red", percent: 0.05},
									]
								)}
							</div>
							<div>
								<p>
									Lessons can be assigned on this page. Learn more about
									assignments{" "}
									<Link
										to={options.supportLinkURL("reports", "assignments")}
										className={styles.link}
									>
										here
									</Link>
									.
								</p>
							</div>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, "class-chapter-report", true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "class-lesson",
			title: "Class Lesson Reports",
			titleLevel: 3,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						<p>
							This report shows how students in a class have done on a specific
							lesson. Up to five attempts are shown for each student, including
							how they have done on specific problems in their most recent play.
						</p>
						{pieGraphIcon(
							styles,
							"Click any lesson or problem icon to view the problem, student responses (where available), and the solution.",
							[
								{color: "green", percent: 0.5},
								{color: "red", percent: 0.5},
							]
						)}
					</div>
					<div className={styles.column6}>
						{screenshot(styles, "class-lesson-report", true)}
					</div>
				</div>
			),
		},
		{
			hash: "class-lesson-reports-attempts",
			title: "Attempts",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						Every student has up to five attempts shown for each lesson, with
						the results given in order from first to last. If a student has
						played a lesson more than 5 times, we show the additional number of
						attempts with a + between the 3rd and the most recent attempt.
					</p>
					<p>
						In the example below, the system intervened during the student’s
						first attempt because they missed some early questions. Later, the
						student went on to score 2 stars, then 3 stars, and then played the
						lesson four more times. They are now partially through their most
						recent attempt.
					</p>
					{attemptsBar(styles, {
						id: "attempts1",
						results: [
							{
								finishStatus: "intervened",
							},
							{
								numStars: 2,
							},
							{
								numStars: 3,
							},
							{},
							{},
							{},
							{},
							{
								percentComplete: 0.25,
							},
						],
					})}
					<p>Their best attempt is given in the column to the right.</p>
					<p>
						Click any lesson icon to view detailed information for that specific
						attempt including individual problems, student responses (where
						available), and solutions.
					</p>
				</div>
			),
		},
		{
			hash: "class-lesson-reports-most-recent-play",
			title: "Most Recent Play",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						The date and set number of the most recent play are given. (Most
						lessons in BA Online have at least three distinct sets of problems.)
						A "G" means that a lesson is a game with many problems.
					</p>
					{pieGraphIcon(
						styles,
						"Indicates a student answered correctly on their first try.",
						[{color: "green", percent: 1}]
					)}
					<br />
					{pieGraphIcon(
						styles,
						"Indicates that a student answered correctly after multiple attempts.",
						[
							{color: "green", percent: 0.5},
							{color: "red", percent: 0.5},
						]
					)}
					<br />
					{pieGraphIcon(
						styles,
						"Indicates that a student answered incorrectly on multiple attempts.",
						[{color: "red", percent: 1}]
					)}
					<br />
					{pieGraphIcon(
						styles,
						"A pie chart gives a summary of progress for all students on each problem.",
						[
							{color: "green", percent: 0.55},
							{color: "red", percent: 0.15},
						]
					)}
					<p>
						Click any problem icon (not the pie chart) to view the problem,
						student responses (where available), and the solution.
					</p>
				</div>
			),
		},
		{
			hash: "class-lesson-reports-totals",
			title: "Totals",
			titleLevel: 4,
			contents: (
				<div>
					<p>Totals are given for problems correct and time.</p>
				</div>
			),
		},
		{
			hash: "class-problem",
			title: "Problem Reports",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							<p>
								Clicking any lesson or problem icon on any report page will open
								detailed information on specific problems. This includes the
								problem, any responses a student made, and the solution.
							</p>
							<p>
								You can navigate to different problems within a lesson by
								clicking the problem circles across the top.
							</p>
							<p>
								Click the Play Problem link in the top-right to play the problem
								in the BA Online classroom in a new browser window.
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, "problem-report", true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "student-report-pages",
			title: (
				<div className={styles.outer}>
					<span className={styles.baoIcon}>G</span>
					STUDENT REPORT PAGES
				</div>
			),
			titleLevel: 1,
			contents: (
				<div>
					<p>
						Student pages allow you to view{" "}
						<Link
							to={options.supportLinkURL("reports", "student-progress")}
							className={styles.link}
						>
							progress
						</Link>
						{" and "}
						<Link
							to={options.supportLinkURL("reports", "student-activity")}
							className={styles.link}
						>
							activity
						</Link>
						{" for a single student."}
					</p>
					{screenshot(styles, "student-report", true, styles.largeScreenshot)}
					<p>
						Below the student’s name are cumulative totals. Learn more about
						what these icons stand for in the{" "}
						<Link
							to={options.supportLinkURL("reports", "icons")}
							className={styles.link}
						>
							icons
						</Link>{" "}
						section above.
					</p>
					<p>
						Use the BA level, chapter, and lesson menus to view specific reports
						for the class. You can view student reports for any BA Level,
						Chapter, or Lesson.
					</p>
					<p>
						You can also navigate by clicking any blue link, including chapter
						names, set numbers (which open the lesson in a new tab) as well as
						dates (which take you to the{" "}
						<Link
							to={options.supportLinkURL("reports", "student-activity")}
							className={styles.link}
						>
							activity calendar
						</Link>{" "}
						for a student).
					</p>
					<div className={styles.learnMoreInfo}>
						{"Click the "}
						<div className={styles.learnMoreIcon}>
							<span>?</span>
						</div>
						{" icon next to any item to view more about it."}
					</div>
				</div>
			),
		},
		{
			hash: "student-progress",
			title: "Progress",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					{"Click the "}
					<div className={styles.reportTab}>
						<span className={styles.reportTabIcon}>E</span>
						Progress
					</div>
					{" tab to view reports on student performance."}
				</div>
			),
		},
		{
			hash: "student-progress-ba-level",
			title: "Student BA Level Reports",
			titleLevel: 3,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						<p>
							This report shows how a student has done across all chapters in a
							single BA level.
						</p>
						{historyIcon(
							styles,
							"stars",
							false,
							"Click any lesson icon to view individual problems, student responses (where available), and solutions.",
							{
								keySuffix: "2stars",
								numStars: 2,
								hideStarIcon: true,
							}
						)}
					</div>
					<div className={styles.column6}>
						{screenshot(styles, "student-report", true)}
					</div>
				</div>
			),
		},
		{
			hash: "student-progress-lessons",
			title: "Lessons",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						This report shows how a student did on their <b>best attempt</b> for
						every lesson in every chapter of a BA level.
					</p>
				</div>
			),
		},
		{
			hash: "student-progress-ba-level-totals",
			title: "Totals",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						Totals are given for stars, trophies, problems correct, and time.
					</p>
				</div>
			),
		},
		{
			hash: "student-progress-chapter-reports",
			title: "Student Chapter Reports",
			titleLevel: 3,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						<p>
							This report shows how a student has done across all of the lessons
							in a single chapter. Up to five attempts are shown for each
							lesson, including how the student has done on specific problems in
							their most recent play.
						</p>
						<p>
							You can click any set number to open the lesson in a new browser
							tab.
						</p>
						{pieGraphIcon(
							styles,
							"Click any lesson or problem icon to view the problem, student responses (where available), and the solution.",
							[
								{color: "green", percent: 0.5},
								{color: "red", percent: 0.5},
							]
						)}
					</div>
					<div className={styles.column6}>
						{screenshot(styles, "student-chapter-report", true)}
					</div>
				</div>
			),
		},
		{
			hash: "student-progress-reports-attempts",
			title: "Attempts",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						Every lesson has up to five attempts shown, with the results given
						in order from first to last. If a student has played a lesson more
						than 5 times, we show the additional number of attempts with a +
						between the 3rd and the most recent attempt.
					</p>
					<p>
						In the example below, the system intervened during the student's
						first attempt because they missed some early questions. Later, the
						student went on to score 2 stars, then 3 stars, and then played the
						lesson four more times. They are now partially through their most
						recent attempt.
					</p>
					{attemptsBar(styles, {
						id: "attempts2",
						results: [
							{
								finishStatus: "intervened",
							},
							{
								numStars: 2,
							},
							{
								numStars: 3,
							},
							{},
							{},
							{},
							{},
							{
								percentComplete: 0.25,
							},
						],
					})}
					<p>Their best attempt is given in the column to the right.</p>
				</div>
			),
		},
		{
			hash: "student-progress-reports-most-recent-play",
			title: "Most Recent Play",
			titleLevel: 4,
			contents: (
				<div>
					<p>
						The date and set number of the most recent play are given. (Most
						lessons in BA Online have at least three distinct sets of problems.)
						A "G" means that a lesson is a game with many problems.
					</p>
					{pieGraphIcon(
						styles,
						"Indicates a student answered correctly on their first try.",
						[{color: "green", percent: 1}]
					)}
					<br />
					{pieGraphIcon(
						styles,
						"Indicates that a student answered correctly after multiple attempts.",
						[
							{color: "green", percent: 0.5},
							{color: "red", percent: 0.5},
						]
					)}
					<br />
					{pieGraphIcon(
						styles,
						"Indicates that a student answered incorrectly on multiple attempts.",
						[{color: "red", percent: 1}]
					)}
					<p>
						Click any problem icon (not the pie chart) to view the problem,
						student responses (where available), and the solution.
					</p>
				</div>
			),
		},
		{
			hash: "student-progress-chapter-totals",
			title: "Totals",
			titleLevel: 4,
			contents: (
				<div>
					<p>Totals are given for problems correct and time.</p>
				</div>
			),
		},
		{
			hash: "student-progress-lesson-reports",
			title: "Student Lesson Reports",
			titleLevel: 3,
			contents: (
				<div className={styles.firstRowContainer}>
					<div className={styles.column4}>
						<p>
							The student lesson report shows how a student has done on a single
							lesson.
							<br />
							If there is a trophy problem available, it is listed at the top.
							<br />
							Attempts are shown chronologically, starting with the most recent.
						</p>
						<p>
							Click any problem or lesson icon to view the problem, student
							responses (where available), and the solution.
						</p>
					</div>
					<div className={styles.column6}>
						{screenshot(styles, "student-lesson-report", true)}
					</div>
				</div>
			),
		},
		{
			hash: "student-problem",
			title: "Problem Reports",
			titleLevel: 3,
			contents: (
				<div>
					<div className={styles.firstRowContainer}>
						<div className={styles.column4}>
							<p>
								Clicking any lesson or problem icon on any report page will open
								detailed information on specific problems. This includes the
								problem, any responses a student made, and the solution.
							</p>
							<p>
								You can navigate to different problems within a lesson by
								clicking the problem circles across the top.
							</p>
							<p>
								Click the Play Problem link in the top-right to play the problem
								in the BA Online classroom in a new browser window.
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, "problem-report", true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "student-activity",
			title: "Activity",
			titleLevel: 2,
			horizontalRule: true,
			contents: (
				<div>
					{"Click the "}
					<div className={styles.reportTab}>
						<span className={styles.reportTabIcon}>A</span>
						Activity
					</div>
					{" tab to view a calendar that displays when a student has played."}
					<div className={styles.rowContainer}>
						<div className={styles.column4}>
							<p>
								The calendar shows the minutes played for each day. This only
								includes time spent in the Classroom (playing lessons), Library
								(reading book sections), Theater (watching instructional
								videos), Puzzle Lab (solving puzzles), and Beast Builder
								(building a monster avatar).
							</p>
							<p>
								Click any day to view a breakdown of time spent in these areas,
								plus a complete list of Lessons Played, Sections Read, Videos
								Watched, and Puzzles Played.
							</p>
							<p>
								Note that the total in the stars column only counts new
								stars—ones that were not earned on a previous attempt.
							</p>
							<p>
								Note that excessive idle time (elapsed time when no mouse,
								touch, or keyboard input is detected) is not counted towards
								these totals.
							</p>
							<p>
								Click any blue lesson number to open the student lesson report.
							</p>
							<p>
								{
									"Learn more about what the icons on this page stand for in the "
								}
								<Link
									to={options.supportLinkURL("reports", "icons")}
									className={styles.link}
								>
									icons
								</Link>
								{" section above."}
							</p>
						</div>
						<div className={styles.column6}>
							{screenshot(styles, "student-report-activity2", true)}
						</div>
					</div>
				</div>
			),
		},
		{
			hash: "class-puzzle-lab-report",
			title: (
				<div className={styles.outer}>
					<span className={styles.baoIcon}>Q</span>
					PUZZLE LAB REPORT PAGES
				</div>
			),
			titleLevel: 1,
			contents: (
				<div>
					<p>
						You can navigate to the Puzzle Lab Reports by clicking the leftmost
						dropdown menu and then clicking Puzzle Lab.
					</p>
					{screenshot(styles, "class-dropdown", false, styles.levelDropdown)}
					<p>
						<b>Puzzle Lab Reports</b>
					</p>
					<p>
						Like other progress reports, you can view Puzzle Lab reports for an
						entire{" "}
						<Link
							to={options.supportLinkURL("reports", "class-report-pages")}
							className={styles.link}
						>
							Class
						</Link>{" "}
						or for an individual{" "}
						<Link
							to={options.supportLinkURL("reports", "student-report-pages")}
							className={styles.link}
						>
							Student
						</Link>
						.
					</p>
					<p>
						For example, the report below shows a single student’s performance
						in all of the puzzle types available in the Puzzle Lab.
					</p>
					{screenshot(styles, "teacherAllTypes", true)}
					<p>
						There are four difficulty levels for puzzle sets in BA Online. The
						difficulty of a Puzzle Set is indicated both by a celestial icon and
						by a shade of purple. In order of difficulty, they are:
					</p>
					{historyIcon(
						styles,
						"moon",
						false,
						"Moon sets are medium difficulty level.",
						{
							celestialEarned: true,
							percentComplete: 1,
							hideStarIcon: true,
						}
					)}
					<br />
					{historyIcon(
						styles,
						"comet",
						false,
						"Comet sets are hard difficulty level.",
						{
							celestialEarned: true,
							percentComplete: 1,
							hideStarIcon: true,
						}
					)}
					<br />
					{historyIcon(
						styles,
						"planet",
						false,
						"Planet sets are expert difficulty level.",
						{
							celestialEarned: true,
							percentComplete: 1,
							hideStarIcon: true,
						}
					)}
					<br />
					{historyIcon(
						styles,
						"galaxy",
						false,
						"Galaxy sets are beast difficulty level",
						{
							celestialEarned: true,
							percentComplete: 1,
							hideStarIcon: true,
						}
					)}
					<br />
					<div>
						Puzzle Set icons{" "}
						{historyIcon(styles, "comet", false, "", {
							celestialEarned: true,
							percentComplete: 1,
							hideStarIcon: true,
							inline: true,
						})}{" "}
						show if a set has been completed or not.
					</div>
					<br />
					{historyIcon(
						styles,
						"moon",
						false,
						"A gray circle means that the puzzle set has not been attempted.",
						{
							celestialEarned: false,
							percentComplete: 0,
							hideStarIcon: true,
							keySuffix: "unearned",
						}
					)}
					<br />
					{historyIcon(
						styles,
						"moon",
						false,
						"A partially filled circle means that the puzzle set is in progress.",
						{
							percentComplete: 0.4,
							hideStarIcon: true,
							keySuffix: "partial",
						}
					)}
					<br />
					{historyIcon(
						styles,
						"moon",
						false,
						"A purple circle means that the puzzle set has been completed.",
						{
							percentComplete: 1,
							celestialEarned: true,
							hideStarIcon: true,
							keySuffix: "earned",
						}
					)}
					<br />
					<p>
						You can click any puzzle type to see more details about student
						progress in its puzzle sets.
					</p>
					{screenshot(styles, "teacherPuzzleType", true)}
					<p>
						Unlike regular lessons, students have unlimited attempts in each
						puzzle in the Puzzle Lab and puzzles are never marked entirely
						incorrect. Students can only play a Puzzle Set only once.
					</p>
					{pieGraphIcon(
						styles,
						"Means that a puzzle has been attempted but not solved yet",
						[
							{color: "gray", percent: 0.5},
							{color: "red", percent: 0.5},
						]
					)}
					<br />
					{pieGraphIcon(
						styles,
						"Means that a student completed the puzzle correctly on their first try.",
						[{color: "green", percent: 1}]
					)}
					<br />
					{pieGraphIcon(
						styles,
						"Means that a student completed the puzzle after multiple attempts.",
						[
							{color: "green", percent: 0.35},
							{color: "red", percent: 0.65},
						]
					)}
					<br />
					<div>
						Click any puzzle set icon{" "}
						{historyIcon(styles, "planet", false, "", {
							percentComplete: 0,
							hideStarIcon: true,
							keySuffix: "planet",
							inline: true,
						})}{" "}
						or problem circle to open a window that shows the problems, student
						responses, and solutions.
					</div>
					<p>
						<b>Puzzle Lab Locks</b>
					</p>
					<p>
						Students will unlock the Puzzle Lab when they do enough work to
						reach XP level 10. After that, new puzzle types will unlock as they
						complete lessons and gain XP.
					</p>
					<p>
						You can unlock the Puzzle Lab and all of its contents before your
						student reaches XP level 10 within the Free Play settings on your
						Account page. Or, you can lock and unlock the Puzzle Lab from the
						All Levels report page. To lock or unlock specific puzzle types or
						puzzle sets, click the lock icons next to each. Learn more in the{" "}
						<Link
							to={options.supportLinkURL("reports", "locks")}
							className={styles.link}
						>
							locks section
						</Link>
						.
					</p>
				</div>
			),
		},
	];
};

module.exports = {
	getCopy,
};
